import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    guestItineraryList: [],
};

const guestItinerarySlice = createSlice({
    name: 'guestItinerary',
    initialState,
    reducers: {
        resetGuestItinerary: () => initialState,
        setGuestItineraryList: (state, action) => {
            state.guestItineraryList = action.payload;
        },
    },
});

export const { resetGuestItinerary, setGuestItineraryList } = guestItinerarySlice.actions;

export default guestItinerarySlice.reducer;
